import { defineStore } from 'pinia'
import { ref, nextTick } from 'vue'

import { geoFindMe } from '../utils/geoloc'
import { stringify } from 'postcss'

export const useLocationStore = defineStore("location", () => {

    const location = ref(null)
    const updating = ref(Boolean)

    async function get(ttl = 60000) {
        //debugger;
        const ts = (new Date()).getTime()
        if (!location || (ts - (location.value?.timestamp || 0) > ttl )) {
            //console.log(`⌛ get location`)
            updating.value = true
            await nextTick() // 👈 lasă Vue să actualizeze DOM-ul (globul devine galben)
            location.value = await geoFindMe()
            updating.value = false
        }

        return location.value
    }

    async function getCoords() {
        await get();
        if (location.value) {
            return {
                latitude: location.value.coords.latitude,
                longitude: location.value.coords.longitude
            }
        }
        return null;
    }
    return { get, getCoords, updating }
})